export default __webpack_public_path__ + "static/media/developer.23e159be.jpg";